import React, { useState, useEffect } from 'react';
import { Timer, useTimeProviderContext } from '@vitvio/time-components';
import { toZonedTime, getDifference } from '@vitvio/helpers';
import { useUserContext } from '@vitvio/user-context';
interface CountdownTimerProps {
  targetTime: Date;
  showRedText?: boolean;
  callback?: () => void;
  isHidden?: boolean;
  restartOnFinish?: boolean;
  labelWhenFinished?: string;
  color?: string;
  showSeconds?: boolean;
}

export const CountdownTimer = ({
  targetTime,
  isHidden = false,
  callback,
  restartOnFinish = false,
  labelWhenFinished = '--:--:--',
  color = 'black',
  showSeconds = true,
}: CountdownTimerProps) => {
  const { hospitalTimezone } = useUserContext();
  const { currentTimeInTimezone } = useTimeProviderContext();
  const [timeLeft, setTimeLeft] = useState(0);
  const [isMounted, setIsMounted] = useState(false);

  // the isMounted state seems to prevent hydration errors
  useEffect(() => {
    setIsMounted(true); // Component has mounted

    const zonedTime = toZonedTime(targetTime, hospitalTimezone);
    const difference = getDifference(currentTimeInTimezone, zonedTime ?? targetTime, 'milliseconds');

    setTimeLeft(difference);

    return () => setIsMounted(false); // Cleanup on unmount
  }, [currentTimeInTimezone, targetTime, hospitalTimezone]);

  return (
    <span>
      {isMounted && (
        <Timer time={timeLeft} labelWhenFinished={labelWhenFinished} color={color} showSeconds={showSeconds} />
      )}
    </span>
  );
};
